import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

import { ToastContainer, toast } from 'react-toastify';

export const SaveTimeLog = async (obj, action) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const isMultiEmployee = Array.isArray(obj.employeeID);
      
      if (isMultiEmployee) {
        const savePromises = obj.employeeID.map(async (employeeID) => {
          const singleEmployeeObj = {
            ...obj,
            employeeID: employeeID,
            timeLogID: obj.timeLogID || 0 
          };
          
          const response = await fetch(`${dev_baseUrl}/ShiftTimeLog/save`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${accesstoken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(singleEmployeeObj),
          });
          
          return await response.json();
        });
        
        const results = await Promise.all(savePromises);
        
        // REMOVED: Don't show toast here, let the component handle it
        // Check if all saves were successful
        const allSuccess = results.every(result => !result.isError);
        
        if (allSuccess) {
          // Return success without toast - component will handle the notification
          return { success: true, results, count: obj.employeeID.length };
        } else {
          // Return failure details without toast - component will handle the notification
          const failedCount = results.filter(result => result.isError).length;
          return { 
            success: false, 
            results, 
            totalCount: obj.employeeID.length,
            failedCount 
          };
        }
      } else {
        // Original single employee logic (keep existing toast for single employee)
        const response = await fetch(`${dev_baseUrl}/ShiftTimeLog/save`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(obj),
        });

        const data = await response.json();
        
        if (response.ok && !data.isError) {
          toast.success(`Timelog ${action === "save" ? "Saved" : "Edited"} Successfully!`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
          return data;
        }  
        
        if (response.ok && data.isError && data.result) {
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
          return data.result[0];
        } else {
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
          return data;
        }
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return;
    }
  } else {
    console.warn("Access token is not available.");
  }
};

export const GetTimeLog = async (obj) => {
  const accesstoken = getToken();
  // console.log(obj)
  
  if (accesstoken) {
    try {

        const response = await fetch(`${dev_baseUrl}/ShiftTimeLog/Get?employeeID=${obj.employeeID}&timeLogId=0&from=${obj.from}&to=${obj.to}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          }
        });

        const data = await response.json();
        
        // Handle the response format
        if (response.ok && !data.isError) {       

            return data;           
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return ;
    }
  } else {
    console.warn("Access token is not available.");
  }

};


export const DeleteTimeLog = async (timeLogId) => {
  const accesstoken = getToken();
  // console.log(obj)
  
  if (accesstoken) {
    try {

        const response = await fetch(`${dev_baseUrl}/ShiftTimeLog/Delete?timeLogId=${timeLogId}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          }
        });

        const data = await response.json();
        
        // Handle the response format
        if (response.ok && !data.isError) {
          // Show success message from the API response
          toast.success(data?.message || "Time Log deleted successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
           
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
              theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return ;
    }
  } else {
    console.warn("Access token is not available.");
  }

};

export const GetEmployees = async (employeeid) => {
  const accesstoken = getToken();
  // console.log(obj)
  
  if (accesstoken) {
    try {

        const response = await fetch(`${dev_baseUrl}/Employee/get/${employeeid}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          }
        });

        const data = await response.json();
        
        // Handle the response format
        if (response.ok && !data.isError) {       

            return data;           
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return ;
    }
  } else {
    console.warn("Access token is not available.");
  }

};